/* ==========================================================================
   SearcherFlight > Client > Discount > Panel > Bonus
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');

const { addData } = require('@bluekiri/alexandria/helpers/dataHelpers');

const RadioButton = require('@bluekiri/alexandria-contrib-components/components/radio-button-rxjs/client/js');
const RadioButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/radio-button-rxjs/template');
const Actions = require('@bluekiri/alexandria-contrib-components/components/radio-button-rxjs/client/js/store/actions');

const { fromEvent } = require('rxjs');

const { addModal } = require('./modal');

const configuration = require('../../../config');

const renderOptions = (options, current) =>
    html(
        options.map(({ label, value }, index) => {
            /* Data */
            return RadioButtonTemplate(
                addData(
                    {
                        label,
                        checked: current === value,
                        name: configuration().type.discount
                    },
                    {
                        type: `${configuration().type.discount}-${index}`
                    }
                )
            );
        })
    );

/* Render */
function renderBonus(instance) {
    /* Data */
    const { bonus } = instance.config;
    const { label, content, items } = bonus;

    /* Value */
    const { value: option } = instance.discount.store.select('input');
    const [{ value }] = items.filter(item => item.label === option);

    return html(`
        <div data-bonus>
            <p class='searcher__title'>${label}</p>
            <div class='searcher__wrapper'>
                ${renderOptions(items, value)}
                <p class='searcher__trigger' data-trigger>${content}</p>
            </div>
        </div>
    `);
}

/* Init */
function initBonus(instance) {
    const panel = instance;

    const { selector } = instance;

    /* Reference */
    const optionsEls = [...instance.discountPanel.element.querySelectorAll(`[data-component='RadioButtonRxjs']`)];

    panel.bonus = {
        trigger: instance.discountPanel.element.querySelector('[data-bonus] [data-trigger]'),
        options: []
    };

    /* Options */
    optionsEls.forEach((item, index) => {
        const ref = RadioButton(
            `${selector} [data-component='RadioButtonRxjs'][data-type='${configuration().type.discount}-${index}']`
        );

        panel.bonus.options = [...instance.bonus.options, ref];

        /* Reactions */
        panel.reactions = {
            ...instance.reactions,
            [`change-option-${index}`]: ref.store.subscribe((state, action) => {
                if (action.type !== Actions.types.TOGGLE) return;

                /* Data */
                const { items } = instance.config.bonus;

                /* Execute action change */
                instance.actions.changeDiscount(items[index]);
            })
        };
    });

    /* Subscriptions */
    panel.subscriptions = {
        ...instance.subscriptions,
        openBonusModal: fromEvent(instance.bonus.trigger, 'click').subscribe(event => {
            event.stopPropagation();

            /* Add Modal */
            addModal(instance);
        })
    };
}

/* Destroy */
function destroyBonus(instance) {
    const panel = instance;

    /* Subscriptions */
    instance.subscriptions.openBonusModal.unsubscribe();
    delete panel.subscriptions.openBonusModal;

    /* Reference */
    instance.bonus.options.forEach((item, index) => {
        instance.reactions[`change-option-${index}`].unsubscribe();

        item.actions.destroy();
    });

    delete panel.bonus;
}

/* Exports */
module.exports = {
    renderBonus,
    initBonus,
    destroyBonus
};
